import { LightTooltip } from '@efacity/react-next-sc';
import { Link as MuiLink } from '@mui/material';
import type { FC } from 'react';
import { AppEnv } from '@efacity/common';

export interface OrganizationNameWithTooltipProps {
  organizationName: string;
  appEnv: AppEnv;
}

export const OrganizationNameWithTooltip: FC<OrganizationNameWithTooltipProps> = ({ organizationName, appEnv }) => {
  const isTestMode = appEnv !== AppEnv.PROD;
  return (
    <LightTooltip title={isTestMode ? `You are in a ${appEnv} environment. Changes will be saved as test data` : ''}>
      <MuiLink color={isTestMode ? 'error' : 'primary'}>
        {isTestMode && organizationName ? `TEST: ${organizationName}` : organizationName}
      </MuiLink>
    </LightTooltip>
  );
};
